const useDocumentTitle = title => {
  document.title = `SurfApp | ${title}`;
};
export default useDocumentTitle;
